const HTML_ESCAPE_MAP: Record<string, string> = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
};

export function escapeHtml(value: unknown): string {
  return String(value ?? '').replace(/[&<>"']/g, (char) => HTML_ESCAPE_MAP[char] || char);
}

export function sanitizeTokenSymbol(value: unknown, fallback = 'TOKEN'): string {
  const raw = String(value ?? '').trim();
  if (!raw) return fallback;

  // Keep symbols readable while blocking markup/control characters.
  const cleaned = raw.replace(/[^A-Za-z0-9._-]/g, '').slice(0, 25);
  return cleaned || fallback;
}
